import { render } from "./finish_screen.vue?vue&type=template&id=838cfd5c&scoped=true"
import script from "./finish_screen.vue?vue&type=script&lang=js"
export * from "./finish_screen.vue?vue&type=script&lang=js"

import "./finish_screen.vue?vue&type=style&index=0&id=838cfd5c&scoped=true&lang=css"

import exportComponent from "/home/kabull/js/vue/iqtest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-838cfd5c"]])

export default __exports__